import "../styles/Navbar.css";
import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { clearUserData, getUserData } from "../utils/authStorage";

import { useAuth } from "../context/AuthContext";
import { FiUser, FiLogOut } from "react-icons/fi";
const Navbar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const location = useLocation();
  const userData = getUserData();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const userName = userData?.user?.name || userData?.email || "User";
  const initials = (name) =>
    name
      ?.split(" ")
      .map((w) => w[0])
      .join("")
      .slice(0, 2)
      .toUpperCase() || "??";
  /**
   * Dynamically determine page title based on current route and query params
   */
  const getPageTitle = () => {
    const pathname = location.pathname;
    const searchParams = new URLSearchParams(location.search);
    const mode = searchParams.get("mode");
    const reportType = searchParams.get("type");

    // Reporting pages
    // Reporting pages
    if (pathname.includes("/reporting")) {
      switch (reportType) {
        case "transactions":
          return "Transaction Reports";

        case "terminal-wise":
          return "Terminal Wise Report";

        case "merchant-wise":
          return "Merchant Wise Report";

        case "city-wise":
          return "City Wise Report";

        case "province-wise":
          return "Region Wise Report";

        case "mcc-wise":
          return "MCC Wise Report";

        case "dvr":
          return "Daily Volume Report";

        default: {
          const status = searchParams.get("status");

          switch (status) {
            case "Total":
              return "Total Transactions";

            case "Settled":
              return "Settled Transactions";

            case "Un-Settled":
              return "Un-Settled Transactions";

            case "Disputed":
              return "Disputed Transactions";

            case "Declined":
              return "Declined Transactions";

            case "Voided":
              return "Voided Transactions";

            case "Today":
              return "Today's Transactions";

            default:
              return "Reporting";
          }
        }
      }
    }
    if (pathname.includes("/merchantslist")) return "All Merchants";
    // Merchant pages
    if (pathname.includes("/merchant")) {
      if (mode === "edit") return "Edit Merchant";
      if (mode === "view") return "View Merchant";
      return "Add Merchant";
    }

    if (pathname.includes("/terminalslist")) return "All Terminals";
    // Terminal pages
    if (pathname.includes("/terminal")) {
      if (mode === "edit") return "Edit Terminal";
      if (mode === "view") return "View Terminal";
      return "Add Terminal";
    }

    if (pathname.includes("/userslist")) return "All Users";
    // User pages
    if (pathname.includes("/user")) {
      if (mode === "edit") return "Edit User";
      if (mode === "view") return "View User";
      return "Add User";
    }

    // Other pages
    if (pathname.includes("/unbind")) return "Unbind Terminal";
    if (pathname.includes("/operations")) return "Reset Terminal Password";
    if (pathname.includes("/hardpos")) return "Hard POS";
    if (pathname.includes("/inventory")) return "Inventory";

    return "Dashboard";
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("token");
      clearUserData();
      logout();
      navigate("/");
    }
  };
  return (
    <nav className="navbar">
      {/* LEFT SIDE */}
      <div className="navbar-left">
        <h1 className="navbar-title">{getPageTitle()}</h1>
      </div>

      {/* RIGHT SIDE */}
      <div className="navbar-right">
        {/* User Profile Dropdown */}
        <div className="profile-wrapper" ref={dropdownRef}>
          <div
            className="profile-avatar"
            onClick={() => setDropdownOpen((prev) => !prev)}
          >
            {" "}
            <FiUser style={{ width: 70 }} />
          </div>
          {/* <span className="profile-name">{userName}</span>
            <FiChevronDown
              className={`profile-chevron ${dropdownOpen ? "open" : ""}`}
            /> */}

          {dropdownOpen && (
            <div className="profile-dropdown">
              <div className="dropdown-header">
                <div className="dropdown-avatar">{initials(userName)}</div>
                <div className="dropdown-user-info">
                  <span className="dropdown-name">{userName}</span>
                </div>
              </div>
              <div className="dropdown-divider" />

              <button className="dropdown-item logout" onClick={handleLogout}>
                <FiLogOut className="dropdown-icon" />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
